export default __webpack_public_path__ + "static/media/480_dummy2016-coach02-de.b4f75f07.png";